<template>
    <div style="padding-bottom: 10px;">
        <el-form ref="formItemRules" :model="formItem" :rules="formItemRules" label-width="200px">
            <h3 class="title-group">3、基础配置</h3>
            <el-form-item prop="plan_status" label="新计划状态：" class="label-required">
                <el-radio-group v-model="formItem.plan_status">
                    <el-radio label="1">关闭</el-radio>
                    <el-radio label="0">开启</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item prop="app_id" label="投放产品：" class="label-required">
                <JtSelect :value="formItem.app_id" placeholder="请选择" style="width: 400px;"
                       ref="planJtSelect"
                      clearable
                      multiple
                      filterable
                       :filter-method="SearchFilter"
                       @visible-change="handleVisible"
                       @change="handleChange"
                >
                    <div :style="{cursor: 'pointer', paddingLeft: '20px', marginBottom: '6px', color: '#409EFF'}">
                        <span :style="{display: 'inline-block'}"  @click="handleAllSelect('all')">全选</span>
                        <span :style="{display: 'inline-block', marginLeft: '10px'}" @click="handleAllSelect('cancel')">取消全选</span>
                    </div>
                    <el-option
                        v-for="item in appList"
                        :key="item.app_id"
                        :label="item.app_name+'（ID:'+item.app_id+'，包名:'+item.package_name+'）'"
                        :value="item.app_id">
                        {{item.app_name}}（ID:{{item.app_id}}，包名：{{item.package_name}}）
                    </el-option>
                </JtSelect>
                <el-button
                    style="margin-left:15px"
                    type="primary"
                    plain
                    @click="handleBatchAppClick"
                >
                    批量录入
                </el-button>
                <div class="text-color-gray font12px mt10" v-if="extensionType != 3">
                    <p>可选产品：选择的目标账户对应的客户已绑定的产品（若无对应产品请联系组长进行产品绑定）</p>
                </div>
                <div class="text-color-gray font12px mt10" v-else>
                    <p>快应用直达链接格式需为：hap://app/快应用包名/参数 或 hap://game/快应用包名/参数，用于直接打开快应用指定页面</p>
                    <p>打底网页地址：打底网页网址需为https开头的链接，用于快应用打开异常时的打底展示</p>
                </div>
            </el-form-item>

            <el-form-item label="" v-if="extensionType == 3">
                <quickFormItem ref="quickFormItemRef" :list="result" :recourse="recourse" @jtClear="handleJtClear" @jtError="handleJtError" @quickInfo="handleQuickInfo" @quickCheck="handleQuickCheck"/>
            </el-form-item>

            <el-form-item label="命名：" class="label-required">
                <p class="mt8 font12px">1、防止重名，在名称尾缀增加当日时间+任务序号+顺序号（示例：捕鱼-信息流-2310910361-1-1、捕鱼-信息流-23100910361-1-2、捕鱼-信息流-23100910361-1-3）</p>
                <p class="font12px mt6 mb6">2、替换产品名称：
                    <el-switch v-model="formItem.replace_name_status" active-value="1" inactive-value="0" class="mini-switch"></el-switch>
                </p>
                <p class="font12px pl20">若开启，则将原计划、组、广告名称中的产品名称修改为新的产品名称 (取其项目名称)，修改规则如下:</p>
                <p class="font12px pl40">a）名称中取第一个“-”，将第一个“-”前边的文字换成新的项目名称;</p>
                <p class="font12px pl40">b）未检测到“-”时，在原名称基础上最前边增加“项目名称-”</p>
                <p class="font12px pl20 text-color-primary">使用Tips：需要修改产品的模板计划，进行统一规范命名，将产品名称填写在最开始，后边拼接“-”如[捕鱼大作战-联盟-自定义xxx】</p>
            </el-form-item>
            <el-form-item prop="default_second_stage" label="免一阶：" class="label-required">
                <el-radio-group v-model="formItem.default_second_stage">
                    <el-radio label="0">关闭</el-radio>
                    <el-radio label="1">开启</el-radio>
                </el-radio-group>
                <p class="text-color-error font12px">CPX的广告组会跳过此设置，仅对oCPX广告组生效</p>
            </el-form-item>
            <el-form-item  label="投放日期：" class="label-required">
                <div class="mb10">
                    <el-button-group>
                        <el-button @click="changeDateType('1')" :type="dateType=='1'?'primary':'default'" class="tab-nav-btn">长期投放</el-button>
                        <el-button @click="changeDateType('2')" :type="dateType=='2'?'primary':'default'" class="tab-nav-btn">指定开始和结束日期</el-button>
                    </el-button-group>
                </div>
                <div v-if="dateType=='2'">
                    <el-date-picker type="daterange" v-model="range1" :picker-options="dateOptions" :clearable="false" value-format="yyyy-MM-dd" key="range1" placeholder="选择开始和结束日期" style="width: 300px"></el-date-picker>
                    <span class="text-color-error font12px ml20" v-if="curHour>=23 && groupStartDate==todayStr">距离第二天不足一小时，请确认开始日期，以免创建失败！</span>
                </div>
            </el-form-item>

            <h4 class="title-group">4、批量规则</h4>
            <el-form-item prop="batch_rules" label="创意上传规则：" class="label-required" style="padding-bottom: 40px;">
                <el-radio-group v-model="formItem.batch_rules">
                    <el-radio-button label="2" v-if="pageFuncNames.includes('oppo_create_config_2')">按照模版计划、广告组、创意规格自动匹配</el-radio-button>
                </el-radio-group>
            </el-form-item>
        </el-form>

        <div>
        </div>
    </div>
</template>
<script>
import {JtSelect} from "@/components/Ele";
import dayjs from "dayjs";
import {batchEnterModal} from "../modal";
import API from "@/api/marketManage/oppoBatch";
import quickFormItem from "@/views/marketingManagement/oppo/components/quickFormItem.vue";
import {uniq} from 'lodash'

export default {
    name: 'oppo_stepsRule',
    components:{quickFormItem, JtSelect},
    props:{
        recourse: {
            type: Object,  // 第一步依赖参数
            default: () => {}
        },
        pageFuncNames:Array,
    },
    data() {
        return {
            formItem:{
                plan_status: '1',
                app_id: [],
                replace_name_status: '1',
                default_second_stage: '1',
                batch_rules:'2'
            },
            formItemRules:{
                plan_status: [
                    { required: true, message: '新计划状态不能为空' },
                ],
                batch_rules:[
                    { required: true, message: '创意上传规则不能为空' },
                ],
                app_id:[
                    { required: true, message: '请选择投放产品', trigger: 'change' }
                ]
            },
            dateType:'1',
            appList:[],
            todayStr: dayjs().format('YYYY-MM-DD'),
            range: dayjs().format('YYYY-MM-DD'),
            range1: [],
            dateOptions:{
                firstDayOfWeek: 1,
                disabledDate (date) {
                    return date && date.valueOf() < Date.now() - 1000*60*60*24;
                }
            },
            instant_app_info:[], //快应用信息
            quick_list:[], //快应用选中列表
            options:[], //appList 的缓存
            result:[],  //快应用选中列表  quickFormItem 用
            is_check_quick: false, //快应用验证
            checkMax: 50,//最大可选择数量
            extensionType: 3, // 3 表示快应用  小游戏
        }
    },
    computed: {
        curHour(){
            return dayjs().hour();
        },
    },
    methods: {
        // 每次都请求获取网页地址
        getUrlList(extensionType) {
            this.extensionType = extensionType
            this.$nextTick(()=>{
                if(extensionType == 3) {
                    this.$refs.quickFormItemRef.fet_quick_list()
                }
            })
        },
        // 父组件 清空子组件
        clearData(extensionType) {
            this.extensionType = extensionType
            this.$refs.formItemRules.resetFields()
            this.formItem = {
                plan_status: '1',
                app_id: [],
                replace_name_status: '1',
                default_second_stage: '1',
                batch_rules:'2'
            }
            this.result = [];
            this.quick_list = [];
            this.is_check_quick = false;

            this.getAppList(extensionType)


            this.$nextTick(()=>{
                if(extensionType == 3) {
                    this.$refs.quickFormItemRef.clearQuickForm()
                }
            })
        },
        // 校验用方法 验证表单 提供给外面验证
        async validateSteps() {
            await this.$refs.formItemRules.validate()
            if(this.extensionType == 3) {
                //快应用验证
                let result = await this.$refs.quickFormItemRef.handleValidate(true)
                return await this.checkAppPackagePageUrl_quick(result)
            }else{
                return  await this.checkAppPackagePageUrl()
            }
        },
        groupStartDate(){
            if(this.dateType=='1') return this.range;
            if(this.dateType=='2') return this.range1[0];
            return "";
        },
        changeDateType(val){
            this.dateType = val;
        },
        // 获取产品列表
        getAppList(extensionType){
            // if(this.formItem.target_account.length<=0) return false;
            API.getAppList({
                app_id:this.recourse.app_id,
                target_account:this.recourse.target_account.join(','),
                account_id:this.recourse.account_id,
                plan_id:this.recourse.plan_id,
                extension_type: extensionType,
                task_id:this.recourse.taskId,
            }).then(res=>{
                let resData = res.data||[];
                this.appList = resData;
                this.options = resData.map(item=>({res_label:`${item.app_name}（ID:${item.app_id}，包名:${item.package_name}）'`, ...item}))
                // let defaultApp = resData.find(item=>item.checked);
                // if(defaultApp){
                //     this.$nextTick(()=>{
                //         this.formItem.app_id = defaultApp.app_id;
                //     })
                // }else{
                //     this.formItem.app_id = [];
                // }

            },err=>{
                console.log('getAppList err',err);
                this.appList = [];
                this.formItem.app_id = [];
            })
        },
        // 非快应用
        checkAppPackagePageUrl(){
            return new Promise((resolve, reject)=>{
                /* 判断预算逻辑 */

                let app_info = this.options.filter(item=>this.formItem.app_id.includes(item.app_id))||[];
                API.checkAppPackagePageUrl({
                    task_id:this.recourse.taskId,
                    app_info:app_info
                }).then(res=>{
                    this.nextStepLoading = false;
                    let res_quick_list = this.options.filter(item=>this.formItem.app_id.includes(item.app_id))||[];
                    resolve({app_list: res_quick_list,formItem:this.formItem, dateType:this.dateType, range1: this.range1, range:this.range});
                },err=>{
                    this.$message.error(err.info||'操作失败');
                    reject();
                });
            })
        },
        // 快应用
        checkAppPackagePageUrl_quick(instant_app_info){
            // this.nextStepLoading = true;
            return new Promise((resolve, reject)=>{
                /* 判断预算逻辑 */
                API.postquick({
                    task_id:this.recourse.taskId,
                    instant_app_info:instant_app_info,
                }).then(res=>{
                    let res_quick_list = this.options.filter(item=>this.formItem.app_id.includes(item.app_id))||[];
                    resolve({app_list: res_quick_list,formItem:this.formItem, dateType:this.dateType, range1: this.range1, range:this.range});
                }).catch((err)=>{
                    this.$message.error(err.info||'操作失败');
                    reject();
                });
            })
        },


        // 全选操作相关逻辑
        handleVisible(value) {
            if(!value) {
                this.appList = []
                this.appList = this.options
            }
        },
        SearchFilter(val) {
            this.appList = this.options.filter(item=> {
                    return item.res_label.toLowerCase().indexOf(val.toLowerCase()) > -1
                }
            )
        },
        handleAllSelect(type) {
            if(type == 'all') {
                let append = this.appList.map(item=>item.app_id)
                let cur_list = uniq([...this.formItem.app_id, ...append])
                let maxLen = cur_list.length
                if(maxLen > this.checkMax) {
                    return this.$message.warning(`目前最多支持选择${this.checkMax}个`)
                }
                this.formItem.app_id = cur_list
                this.result = this.options.filter(item=>this.formItem.app_id.includes(item.app_id))
            }else{
                let optionList_ids = this.appList.map(item=>item.app_id)
                let channel_ids = this.formItem.app_id.filter(item=> !optionList_ids.includes(item))
                this.formItem.app_id = [...channel_ids]
                this.result = this.options.filter(item=>this.formItem.app_id.includes(item.app_id))
            }
            this.$refs['planJtSelect'].blur()
        },
        handleChange(value) {
            let maxLen = value && value.length
            if(maxLen > this.checkMax) {
                return this.$message.warning(`目前最多支持选择${this.checkMax}个`)
            }
            this.formItem.app_id = value

            if(this.extensionType == 3) {
                this.result = this.options.filter(item=>value.includes(item.app_id))
            }
        },
        //批量录入
        handleBatchAppClick(){
            batchEnterModal({
                props: {
                    appList:this.options,
                    ids: this.formItem.app_id
                },
                cbs: {
                    onSubmit:(list)=>{
                        list.forEach(item=>{
                            if(!this.formItem.app_id.includes(item.app_id)){
                                this.formItem.app_id.push(item.app_id);
                            }
                        })
                        this.$refs.formItemRules.clearValidate(['app_id'])
                        this.result = this.options.filter(item=>this.formItem.app_id.includes(item.app_id))
                    },
                }
            })
        },

        // 快应用逻辑
        handleJtError(params) {
            this.$refs.planJtSelect.setTagState(params.id, params.tips)
        },
        handleJtClear() {
            this.$refs.planJtSelect.delAllTagState()
        },
        handleQuickInfo(params) {
            // let res_quick_list = this.appList.filter(item=>this.formItem.app_id.includes(item.app_id))||[];
            // this.instant_app_info = params;
            // this.quick_list= res_quick_list
            this.$emit('changeLoading')
        },
        handleQuickCheck(value) {
            this.is_check_quick = value;
        }
    }
}
</script>
